export class ApprovalRequest {
    shipyardiApi: string;
    iAPIVesselId: string;
    shipyardId: string;
    vesselId: string;
    vesselName: string;
    approverName: string;
    approverEmail: string;
    approverOid: string;
    ownerName: string;
    ownerEmail: string;
    ownerOid: string;
    version: string;
    reason: ApprovalReason;
    publishRequestId?: string;
}

export class ApprovalReason {
    customerRequest: boolean;
    misconfiguration: boolean;
    internalRequest: boolean;
    other: string;
    comment: string;
}

export enum PublishRequestStatus {
    Undefined = 'undefined',
    Pending = 'publish-pending',
    Accepted = 'publish-accepted',
    Rejected = 'publish-rejected',
    Removed = 'publish-removed',
}
